export const isVersionSameOrHigher = (
	lowestVersion: string,
	currentVersion: string
) => {
	if (currentVersion === 'master') return true

	let cleanVersion = currentVersion.split('ST')[0]

	if (isNaN(Number(cleanVersion[cleanVersion.length - 1]))) {
		cleanVersion = cleanVersion.slice(0, -1)
	}

	const lowestVersionNumber = lowestVersion.replaceAll('.', '').replace('v', '')
	const cleanVersionNumber = cleanVersion.replaceAll('.', '').replace('v', '')

	if (lowestVersionNumber === cleanVersionNumber) {
		return true
	}

	const currentVersionDigits = cleanVersion.replace('v.', '').split('.')
	const lowestVersionDigits = lowestVersion.replace('v.', '').split('.')

	let isAllow = false

	for (let i = 0; i < currentVersionDigits.length; i++) {
		const currentNumber = +currentVersionDigits[i] || 0
		const lowestNumber = +lowestVersionDigits[i] || 0

		if (currentNumber > lowestNumber) {
			isAllow = true

			break
		} else if (currentNumber < lowestNumber) {
			isAllow = false

			break
		}
	}

	return isAllow
}
